// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__Kjp4p","clear":"Tag_clear__mJBIx","selected":"Tag_selected__bKow-","text":"Tag_text__Gdv9M","disabled":"Tag_disabled__cYGAv"};